import React from "react"
export const HeaderShape: React.FC = () => {
  return (
    <div className="shape">
      <svg width="1920" height="500" viewBox="0 0 1920 500">
        <defs>
          <clipPath>
            <rect width="1920" height="500"></rect>
          </clipPath>
        </defs>
        <g data-name="Shape">
          <rect
            data-name="Rectangle"
            width="2356"
            height="781"
            transform="translate(-136.868 401.948) rotate(-11)"
            fill="#fff"
          ></rect>
        </g>
      </svg>
    </div>
  )
}
